/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API49820Item {
  
  /** 战役项目编号 */
  projectNo?: string;
  
  /** 战役项目名 */
  name?: string;
  
  /** 项目Logo */
  logo?: string;
  
  /** 项目级别1:超S级2:S级3:A级4:B级5:X级 */
  level?: number;
  
  /** 项目周期：1:成熟2:孵化3:筹备 */
  growStatus?: number;
  
  /** 项目状态（1：正常；2：风险；3：失控） */
  status?: number;
  
  /** 项目进度 ,ProjectProgressResp */
  progress?: any;
  
  /** 项目描述 */
  desc?: string;
  
  /** 项目进度（61.23%存6123） */
  projectProgress?: number;
  
  /** 时间进度（61.23%存6123） */
  timeProgress?: number;
  
  /** 业务分类：1.基础业务2.创新业务3.投资业务 */
  businessType?: number;
  
  /** 健康标志：0-10 */
  healthFlag?: number;
  
  /** 当前项目的主业务,默认0 */
  parentProjectNo?: string;
  
  /** 子项目列表 ,ProjectInfoViewResp */
  subProjectList?: undefined[];
  
  /** 启用状态：1.启用2.停用 */
  enableStatus?: number;
  
};
    
  



export interface API49820Req {
  
  /** 业务分类：0.无业务类型数据1.基础业务2.创新业务3.投资业务 */
  businessType?: string;
    
  /** 启用状态：1.启用2.停用 */
  enableStatus?: string;
    
};



export interface API49820Res {
  /** T  */
  list?: API49820Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 49820 获取项目列表-视图模式

export interface IUseGetAPI49820Return {
  /** 获取项目列表-视图模式: 接口请求状态 */
  isAPI49820Loading: boolean;
  /** 获取项目列表-视图模式: 接口请求返回数据 */
  dataAPI49820: API49820Res;
  /**  获取项目列表-视图模式: 接口数据请求方法 */
  fetchAPI49820Data:  (inputs: API49820Req, config?: YWRequestConfig) => Promise<API49820Res>;
  /** 获取项目列表-视图模式: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI49820 = ():IUseGetAPI49820Return => {
  let isMount = true;
  const [isAPI49820Loading, setIsAPI49820Loading] = useState(false);
  const [dataAPI49820, setDataAPI49820] = useState<API49820Res>({} as API49820Res);
  const requestUrl = `${basePath}/corp-admin/project/list/view/v1`;

  const fetchAPI49820Data = async (inputs: API49820Req, config?: YWRequestConfig): Promise<API49820Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API49820Req>) || {}) as API49820Req;
    
  
    if ( isMount ) {
      setIsAPI49820Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API49820Res>(`${basePath}/corp-admin/project/list/view/v1?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI49820(res || {} as API49820Res);
        setIsAPI49820Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI49820Loading(false);
      }
      return false as unknown as API49820Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI49820Loading,
    dataAPI49820,
    fetchAPI49820Data,
    requestUrl,
  }
}

